/**
 * Stable CSS class names for E2E — Schedule service wrapper.
 */
export const SW = {
    page: 'schedule-wrapper-page',
    loadingRow: 'schedule-wrapper-page__loading-row',
    loadingSection: 'schedule-wrapper-page__loading-section',

    listHeaderRow: 'schedule-wrapper-page__list-header-row',
    listBreadcrumb: 'schedule-wrapper-page__list-breadcrumb',
    addButton: 'schedule-wrapper-page-input--button-add',

    listSection: 'schedule-wrapper-page__list-section',
    detailSection: 'schedule-wrapper-page__detail-section',
    createSection: 'schedule-wrapper-page__create-section',
} as const;

export const swCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

